import { DestroyLevelDocument, DestroyLevelMutation } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useDestroyLevel = () => {
  const [mutate] = useMutation(DestroyLevelDocument, {
    extractorFn: (data: DestroyLevelMutation) => data.jobCatalogMutations.destroyJobcatalogLevel,
  })

  const destroyLevel = (id: string) => {
    return mutate({ variables: { id } })
  }

  return destroyLevel
}

export default useDestroyLevel
